import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { setBIField } from '../../flow/biForm/actions';
import BIForm from './BIForm';

const { Invoice } = Enums.DetailModules;

const defaultProps = {};
const propTypes = {
  setBIField: PropTypes.func.isRequired,
};


class BillingInfo extends Component {
  handleFieldsChange = fields => this.props.setBIField(fields)

  render() {
    const { form, countries, readOnlyMode } = this.props;
    return (
      <BIForm
        countries={countries}
        onChange={this.handleFieldsChange}
        readOnlyMode={readOnlyMode}
        {...form}
      />
    );
  }
}


BillingInfo.defaultProps = defaultProps;
BillingInfo.propTypes = propTypes;
const mapStateToProps = ({ global, invoice, clientDetails }) => ({
  countries: global.settings.countries,
  form: invoice.biForm,
  readOnlyMode: clientDetails.subpanels.moduleReadonlyMode[`${Invoice}ReadonlyMode`],
});
const mapDispatchToProps = {
  setBIField,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingInfo);



// WEBPACK FOOTER //
// ./src/views/Invoice/components/BillAddress/BillingInfo.jsx